module.exports = __webpack_public_path__ + "media/images/autopilot/settings-956c8cbd25644fe8d1b00ef2cbb9d618.svg";